import { IMessage, UserTypeEnum } from "@cai-services";
import { Quote } from "./quote.model";
import { User } from "./user.model";

export class Message implements IMessage {
  userType: UserTypeEnum;
  user: User;
  messageId: number;
  textMessage: string;
  timeStamp: Date;
  isUserLogin: boolean;
  quote: Quote;

  constructor (
    user: User,
    timeStamp: Date,
    textMessage: string,
    isUserLogin: boolean,
    userType: UserTypeEnum,
    quote: Quote,
    messageId?: number
  ) {
    this.userType = userType;
    this.user = user;
    this.messageId = messageId;
    this.textMessage = textMessage;
    this.isUserLogin = isUserLogin;
    this.timeStamp = new Date(timeStamp);
    this.quote = quote;
  }
}
